<template>
  <div class="content">
    <TopBar />
    <router-view></router-view>
  </div>
</template>

<script>
import TopBar from '@/views/layouts/TopBar';

export default {
  name: 'Content',
  components: { TopBar },
};
</script>
